module.exports = __webpack_public_path__ + "static/media/no_chats.5ed83213.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_chats.svg
// module id = 1216
// module chunks = 0